import { inject } from '@angular/core';
import { AppUpdateService } from '../services/app-update.service';

export function manageAppUpdateInitializer(): Promise<void> {
  return inject(AppUpdateService).init();
}
